import { Injectable } from '@angular/core';
import { ILogger, LogContext } from './ilogger';

// This service is used when the telemetry backend is unavailable.
@Injectable()
export class FallbackLoggerService implements ILogger {
  debug(message: string, context?: LogContext): void {
    void message;
    void context;
    // Intentionally empty.
  }

  info(message: string, context?: LogContext): void {
    void message;
    void context;
    // Intentionally empty.
  }

  warn(message: string, context?: LogContext): void {
    void message;
    void context;
    // Intentionally empty.
  }

  error(message: string, context?: LogContext): void {
    console.error(message, context);
  }

  exception(error: unknown, context?: LogContext): void {
    console.error(error, context);
  }
}
